export default {
  title: {
    en: 'All Sports',
  },
  top: {
    en: 'Hot Events',
  },
}
